export default __webpack_public_path__ + "static/media/art-pro-red-1.13062c3b.png";